import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";



class EhgtvGelirTuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "EhgtvGelirTuru";
    super(baseUrl);
  }


  getEhgtvGelirTuru(yili: number,butceGelirId?: number){
    var request= new EhgtvGelirTuruRequest(yili,butceGelirId);
    
    return this.get("", { params: { yili: yili, butceGelirId: butceGelirId } });

  }

}


export default new EhgtvGelirTuruAPI();
class EhgtvGelirTuruRequest {
  public butceGelirId?: number;
  public yili: number;
 
  constructor(yili: number,butceGelirId?: number) {
   
      this.butceGelirId = butceGelirId;
      this.yili = yili;
      
  }
}
export { EhgtvGelirTuruRequest };